import { createClient } from "@wix/sdk";
import { site } from "@wix/site";
import { currentCart } from "@wix/ecom";
import { products } from "@wix/stores";
import { currentMember } from "@wix/site-members";
import { members } from "@wix/members";
import { ecom } from "@wix/site-ecom";

window.OnVoardData = window.OnVoardData || {};

function normalizeConfigValue(value) {
  if (typeof value !== "string") {
    return undefined;
  }

  let trimmed = value.trim();
  return trimmed || undefined;
}

function readBootstrapConfigFromGlobals() {
  let globalConfig = window.OnVoardData || {};

  return {
    accountId:
      normalizeConfigValue(globalConfig.account_id) ||
      normalizeConfigValue(globalConfig.accountId),
    wixAppId:
      normalizeConfigValue(window.OV_MARKETING_PLATFORM_WIX_APP_ID) ||
      normalizeConfigValue(window.OV_REPERKS_WIX_APP_ID) ||
      normalizeConfigValue(window.OV_PROMPT_WIX_APP_ID) ||
      normalizeConfigValue(window.OV_RECOMMENDER_WIX_APP_ID) ||
      normalizeConfigValue(window.OV_REVIEWS_WIX_APP_ID) ||
      normalizeConfigValue(window.OV_BACK_IN_STOCK_WIX_APP_ID) ||
      normalizeConfigValue(window.OV_AOV_PROGRESS_BAR_WIX_APP_ID) ||
      normalizeConfigValue(globalConfig.wix_app_id) ||
      normalizeConfigValue(globalConfig.wixAppId),
  };
}

const { accountId, wixAppId } = readBootstrapConfigFromGlobals();
let injectAccessTokenFunction = () => undefined;

if (!wixAppId) {
  console.error(
    "Missing Wix applicationId"
  );
} else {
  const wixClient = createClient({
    host: site.host({ applicationId: wixAppId }),
    auth: site.auth(),
    // @wix/members (members.getCurrentMember) is a backend module that runs
    // over the injected access token — unlike @wix/site-members currentMember,
    // which is a frontend host module Wix does NOT bridge into third-party
    // embedded scripts (getMember() throws `undefined.members` there).
    modules: { products, currentCart, currentMember, members, ecom },
  });

  window.OnVoardData.wixClient = wixClient;
  window.OnVoardData.wix_app_id = wixAppId;
  injectAccessTokenFunction = wixClient.auth.getAccessTokenInjector();
  window.OnVoardData.injectAccessTokenFunction = injectAccessTokenFunction;
  window.injectAccessTokenFunction = injectAccessTokenFunction;

  if (!window.OV_ATTACHED_LOADER) {
    window.OnVoardData["account_id"] = accountId;
    window.OV_ATTACHED_LOADER = 1;

    const loaderUrl = `${BASE_LOADER_URL}/apps/loader.js`;
    await import(/* webpackIgnore: true */ loaderUrl);
  }
}

export { injectAccessTokenFunction };
